<ul>
  <ng-container *ngFor="let item of list; let i = index">
    <li>
      <a
        [attr.id]="'footer-links-internos-' + item.url + '-' + i"
        (click)="redirectTo(item)"
        (keyup.enter)="redirectTo(item)"
        [attr.tabindex]="0"
        >{{ item.title }}
        @if (item?.additionalTitle) {
          <span class="text-capitalize">
            {{ item.additionalTitle }}
          </span>
        }
      </a>
    </li>
  </ng-container>
</ul>
